import { render, staticRenderFns } from "./ProfitProductOrderByQty.vue?vue&type=template&id=70ac5f4a&scoped=true"
import script from "./ProfitProductOrderByQty.vue?vue&type=script&lang=js"
export * from "./ProfitProductOrderByQty.vue?vue&type=script&lang=js"
import style0 from "./ProfitProductOrderByQty.vue?vue&type=style&index=0&id=70ac5f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac5f4a",
  null
  
)

export default component.exports